import {
  FlatType,
  FloorType,
  State,
  StreetType,
} from '@energy-retailer/constants';
import { z } from 'zod';

export const fullPropertyAddressSchema = z.object({
  country: z.string().default('AUSTRALIA'),
  dpid: z.string().optional(),
  flatNumber: z.string().optional(),
  flatType: z.nativeEnum(FlatType).optional(),
  floorNumber: z.string().optional(),
  floorType: z.nativeEnum(FloorType).optional(),
  full: z.string(),
  houseNumber: z.number().optional(),
  houseSuffix: z.string().optional(),
  houseNumberTo: z.number().optional(),
  houseNumberToSuffix: z.string().optional(),
  id: z.string().default(''),
  postcode: z.string(),
  state: z.nativeEnum(State),
  streetName: z.string(),
  streetSuffix: z.string().optional(),
  streetType: z.nativeEnum(StreetType),
  suburb: z.string(),
});

export type FullPropertyAddressSchema = z.infer<
  typeof fullPropertyAddressSchema
>;
